module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-01-71b147e8b9e80479f50bc0aa2e1772d7.jpg";